/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type CartTipFragment = {
  __typename: 'Cart'
  id: number | null
  tipPercentage: number | null
  amountCustomTip: {
    __typename: 'Money'
    cents: number
    formatted: string
  } | null
}

export const CartTipFragment = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cartTipFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Cart' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tipPercentage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountCustomTip' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formatted' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
